import styled from 'styled-components'
import Box from 'components/shared/Box'
import { respondAbove } from 'styles/mediaQueries'

export const CalendarBox = styled(Box)`
    width: 100%;
    height: 100%;
    min-height: 500px;
    padding: 16px;
    justify-content: center;
    align-items: center;

    @media ${respondAbove.md} {
        max-width: 100%;
        width: 786px;
        min-height: 500px;
        padding: 40px;
    }
`
